const ru_checker_data = ["йцукенгшщщзхъфывапролджэёячсмитьбю"];

const ru_map = {
  "q": "й",
  "w": "ц",
  "e": "у",
  "r": "к",
  "t": "е",
  "y": "н",
  "u": "г",
  "i": "ш",
  "o": "щ",
  "p": "з",
  "[": "х",
  "{": "Х",
  "]": "ъ",
  "}": "Ъ",
  "|": "/",
  "`": "ё",
  "~": "Ё",
  "a": "ф",
  "s": "ы",
  "d": "в",
  "f": "а",
  "g": "п",
  "h": "р",
  "j": "о",
  "k": "л",
  "l": "д",
  ";": "ж",
  ":": "Ж",
  "'": "э",
  "\"": "Э",
  "z": "я",
  "x": "ч",
  "c": "с",
  "v": "м",
  "b": "и",
  "n": "т",
  "m": "ь",
  ",": "б",
  "<": "Б",
  ".": "ю",
  ">": "Ю",
  "/": ".",
  "?": ",",
  "@": "\"",
  "#": "№",
  "$": ";",
  "^": ":",
  "&": "?"
};

const ru_checker = text => {
  if (typeof text !== 'string') {
    return false;
  }

  for (let i = 0, len = text.length; i < len; ++i) {
    if (ru_checker_data.indexOf(text[i]) !== -1) {
      return true;
    }
  }
  return false;
};

const en_map = Object.entries(ru_map).reduce((acc, item) => {
  (acc[item[1]] = item[0]);
  return acc;
}, {});

const convert = (text, map, doConversion) => {
  if (typeof text !== 'string' || !doConversion) {
    return text;
  }

  let output = '';

  for (let i = 0; i < text.length; ++i) {
    output = output + (map[text[i]] || text[i]);
  }

  return output;
};

export default {
  en: (text) => convert(text, en_map, !ru_checker(text)),
  ru: (text) => convert(text, ru_map, ru_checker(text)),
}
